import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/useLinkedAccountsQueryKeys.ts
var t = e("linkedAccounts", { list: () => ["list"] });
//#endregion
export { t as linkedAccountsQueryKeys };
